import React from 'react'
import AboutBanner from './AboutBanner'
import WhoWeAre from './WhoWeAre'
import AboutOwned from './AboutOwned'
import MissionSection from './AboutMission'
import ProjectStats from '../../Common/ProjectStats/ProjectStats'
import TestimonialSlider from '../../Common/TestimonialSlider/TestimonialSlider'
import OurSaftyCommitment from './OurSaftyCommitment'
function About() {
  return (
    <div>
      <AboutBanner/>
      <WhoWeAre/>
      <OurSaftyCommitment/>
      <MissionSection/>
      <AboutOwned/>
      <ProjectStats/>
      <TestimonialSlider/>
    </div>
  )
}

export default About
